/**
 * Safety Hub API — Ecosystem Gap 7
 *
 * API client for the Safety Hub aggregation endpoint.
 */

import api from './client';

export interface SafetyHubSummary {
  safeword: {
    configured: boolean;
    hasEmergencyContact: boolean;
  };
  relationships: {
    activeHierarchies: number;
    activeMentorships: number;
    pendingMentorshipRequests: number;
  };
  limits: {
    lastReviewedAt: string | null;
    totalLimits: number;
  };
  blocks: {
    blockedCount: number;
  };
  reports: {
    pendingReportsCount: number;
  };
  verification: {
    ageVerified: boolean;
    ageMethod: string | null;
    phoneVerified: boolean;
    emailVerified: boolean;
  };
}

export const safetyHubAPI = {
  /** Get consolidated safety status for the authenticated user */
  getSummary: () =>
    api.get<{ success: boolean; data: SafetyHubSummary }>('/safety-hub/summary'),
};
